import styled from 'styled-components';
import { device, getWidthRange, breakpoints} from '../../utils/responsive_utilities';
import { fontQuicksand } from './mixin';

export const Reviews = styled.div`
  display: flex;
  background-color: #C2C4FF;
  align-items: center;
  justify-content: center;
  width: 25%;
  overflow-y: auto;
  /* padding-top: 8rem; */
  @media ${device.Phone} {
    display: none;
  }
  @media ${device.PhoneLargeScreen} {
    display: none;
  }
  @media ${getWidthRange(767, 1025)} and (orientation: portrait) {
    display: none;
  }
`;

export const Review = styled.div`
  margin: 3.5rem;
  @media ${getWidthRange(breakpoints.lg, 1200)} and (orientation: landscape) {
    margin: 2.5rem 2rem;
  }
`

export const Title = styled.div`
  color: #141953;
  font: italic bold 1.8rem/2.2rem Graphie;
  @media ${getWidthRange(breakpoints.lg, 1200)} and (orientation: landscape) {
    font: italic bold 1.4rem/2rem Graphie;
  }
`;


export const Name = styled.p`
  font: normal ${props=>props.bold ? 700 : 500} 1.2rem/1.6rem Graphie;
  color: #4F52C3;
`;

export const ParentInfoWrap = styled.div`
  display: flex;
  margin: 1rem 0;
  align-items: flex-end;
  img {
    margin-right: 0.7rem;
    border-radius: 50%;
    height: 3.6rem;
    width: 3.6rem;
  }
`;

export const FilterTab = styled.div`
  overflow: hidden;
  border: 1px solid #3B3283;
  width: 45rem;
  margin: 3rem auto 2rem;
  border-radius: 25px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  visibility: ${(props) =>(
   props.userLandsOnAllPlansPage ? 'visible' : 'hidden'
  )};
  @media ${device.PhoneLargeScreen} {
    width: 34rem;
    margin: 2rem auto 1rem;
  }
  @media ${device.Phone} {
    width: 32rem;
    margin: 2rem auto 1rem;
  }
  /* transition: all 1s ease; */
`;

export const Filter = styled.a`
  background-color: ${(props)=>(
    props.active ? '#2284E2' : 'transparent'
  )};
  color: ${(props)=>(
    props.active ? '#fff' : '#7D8CE7'
  )};
  transition: all cubic-bezier(.88, -.35, .565, 1.35) 0.1s;
  transition-property: color, background-color;
  padding: 1rem;
  width: ${props=>props.isMath ? '60%' : '100%'};
  ${fontQuicksand(1.5, 2.3, 7)}
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.3, 1.7, 7)}
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.3, 1.7, 7)}
  }
`;

export const MoneyBackWidget = styled.div`
  background-color: #AAACFF;
  margin: 0 auto;
  img {
    width: 15.5rem;
  }
`;
